import { Injectable } from '@angular/core';
import { mspFileInterface } from 'src/app/util/interfaces/mspFile';
import { CryptoService } from '../crypto/crypto.service';
import { mimeTypeInterface } from 'src/app/util/interfaces/mimeTypeInterface';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class FilesService {
	private getAllowedFileTypesUrl = environment.baseApiUrl + 'customer/mimetype';

	constructor(
		private CryptoService: CryptoService,
		private AuthLoginService: AuthLoginService,
		private http: HttpClient
	) {}

	headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	MSPFileFromFile(file: File): Promise<mspFileInterface> {
		return new Promise<mspFileInterface>((resolve, reject) => {
			const fileExtension = file.name.split('.').at(-1).toLowerCase();
			let fileType = file.type;
			if (fileExtension == 'msg') fileType = 'application/vnd.ms-outlook';

			const mspFile: mspFileInterface = {
				content: '',
				extension: fileExtension,
				mimeType: fileType,
				name: file.name.replace(/\..+$/, ''),
				size: file.size,
				checkSum: '',
				file_path: '...',
			};
			this.baseFromFile(file, 'Base64').then((fileB64) => {
				mspFile.content = this.CryptoService.fuseB64Key(fileB64);
				mspFile.checkSum = fileB64;
				resolve(mspFile);
			});
		});
	}

	baseFromFile(file: File, base: 'Base64' | 'Byte'): Promise<string> {
		return new Promise<string>((resolve, reject) => {
			const reader = new FileReader();

			if (base === 'Base64') {
				reader.readAsDataURL(file);
			}
			if (base === 'Byte') {
				reader.readAsArrayBuffer(file);
			}
			reader.addEventListener('load', () => {
				if (base === 'Base64') {
					const fileToNewBase = reader.result.toString().split(',')[1];
					resolve(fileToNewBase);
				}

				if (base === 'Byte') {
					const biteArray = new Uint8Array(<ArrayBuffer>reader.result);
					const fileByteArray = [];
					for (const element of biteArray) {
						fileByteArray.push(element);
					}
					resolve(biteArray.toString());
				}
			});
			reader.onerror = function (error) {
				throw new Error('Error converting file');
			};
		});
	}

	fileFromBase(mspFile: mspFileInterface, base: 'Base64' | 'Byte'): File {
		let newFile: File;
		if (base === 'Base64') {
			newFile = this.b64toFile(mspFile.content, mspFile.mimeType, `${mspFile.name}.${mspFile.extension}`);
		}
		if (base === 'Byte') {
			throw new Error('getFileFromBase by base Byte not implemented yet');
		}

		return newFile;
	}

	private b64toFile(base64: string, mime: string, filename: string): File {
		const b64string = atob(base64);
		let b64length = b64string.length;
		const u8array = new Uint8Array(b64length);

		while (b64length--) {
			u8array[b64length] = b64string.charCodeAt(b64length);
		}
		return new File([u8array], filename, { type: mime });
	}

	downloadFile(file: File): void {
		const blob = new Blob([file], { type: file.type });

		const link = document.createElement('a');
		// create a blobURI pointing to our Blob
		link.href = URL.createObjectURL(blob);
		link.download = file.name.slice(0, Math.max(0, file.name.lastIndexOf('.')));
		// some browser needs the anchor to be in the doc
		document.body.append(link);
		link.click();
		link.remove();
		// in case the Blob uses a lot of memory
		setTimeout(() => URL.revokeObjectURL(link.href), 7000);
	}

	getAllowedMimeType(): Observable<mimeTypeInterface[]> {
		return this.http.get<mimeTypeInterface[]>(this.getAllowedFileTypesUrl, { headers: this.headers });
	}

	nameAllowed(file: File): boolean {
		const name = file.name;
		const nameReg = /^[\w ()À-ÿ\-]+(\.[\dA-Za-zÀ-ÿ]+)?$/;

		return nameReg.test(name);
	}
}
